export default __webpack_public_path__ + "alberta-sort-9-to-1.ea75fe9d5ad9adfad748.svg";